import React from "react";

const ReferredUserItem = ({
  referral: {
    referredUserName,
    referredUserNameTemp,
    referredUserMobile,
    ...referral
  }
}) => (
  <li className="user-list__item">
    <p className="user-list__mobile">
      {referredUserName || referredUserNameTemp || referredUserMobile}
    </p>
    {displayStatus(referral)}
  </li>
);

const displayStatus = ({ referralStatus, hoursDriven }) => {
  switch (referralStatus) {
    case "sent":
      return (
        <p className="user-list__status user-list__status--sent">
          Invite sent
        </p>
      );
    case "registered":
      return (
        <p className="user-list__status user-list__status--registered">
          Registered
        </p>
      );
    case "pending":
      return (
        <p className="user-list__status user-list__status--registered">
          Pending
        </p>
      );
    case "operating":
      return (
        <p className="user-list__status user-list__status--registered">
          {hoursDriven} / 20 hrs
        </p>
      );
    case "redeemed":
      return (
        <p className="user-list__status user-list__status--redeemed">
          Redeemed
        </p>
      );
    default:
      return (
        <p className="user-list__status user-list__status--sent">
          Invite sent
        </p>
      );
  }
};

export default ReferredUserItem;



// WEBPACK FOOTER //
// ./src/components/Referral/ReferredUserItem.js